import { z } from "zod";

const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;

export const CreateOrganizationSchema = z
  .object({
    name: z.string().trim().min(1).max(100),
    slug: z
      .string()
      .trim()
      .toLowerCase()
      .regex(SLUG_RE, "Slug must be 1-40 chars, lowercase alphanumeric or hyphen"),
    customerDomain: z.string().trim().min(1).max(255).optional(),
    logoUrl: z.url().nullable().optional(),
  })
  .strict();

export type CreateOrganizationBody = z.infer<typeof CreateOrganizationSchema>;
